import React, { useState } from 'react';
import { Tooltip, Typography } from '@forgeglobal/design-framework';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { useStyles } from './style';

const DataAsOfTooltip = ({ note }) => {
  const classes = useStyles();
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
  return (
    <Typography className={classes.note} variant="body2">
      {note}
      <ClickAwayListener onClickAway={() => setTooltipIsOpen(false)}>
        <Tooltip
          open={tooltipIsOpen}
          onOpen={() => setTooltipIsOpen(true)}
          onClose={() => setTooltipIsOpen(false)}
          classes={{
            tooltip: classes.tooltip,
            arrow: classes.tooltipArrow,
          }}
          title={
            <Typography variant="body2" className={classes.tooltipTypography}>
              This indicates the last time system-wide account data was updated.
            </Typography>
          }
          placement="right"
          arrow>
          <InfoOutlined
            className={classes.tooltipIcon}
            onClick={() => setTooltipIsOpen(true)}
          />
        </Tooltip>
      </ClickAwayListener>
    </Typography>
  );
};

export default DataAsOfTooltip;
